import { useContext, useState } from 'react';
import { Trans } from '@lingui/react';
import { useNavigate } from 'react-router-dom';
import { ActionIcon, Group, Menu, Text } from '@mantine/core';
import { IconBallpen, IconDots, IconTrash } from '@tabler/icons';
import TemplatePreview from '../Templates/TemplatePreview';
import { ModalDialog, useModalState } from '../../Dialogs';
import { TransButtonDefault, TransButtonPrimary } from '../../../Atoms/Buttons';
import GenericTemplateName from '../GenericTemplateName';
import { DocumentTemplateContext } from '../../../Service/Context/DocumentTemplateContext';
import { DocumentTemplateS } from '../../../Service/DocumenteTemplateS';
import { openDeleteConfirmModal } from '../../../Atoms/DeleteConfirmModal';

const DocumentTemplateActions = () => {
  const { bookitupDocument } = useContext(DocumentTemplateContext);
  const { show, toggle } = useModalState();
  const navigate = useNavigate();
  const [newName, setNewName] = useState(bookitupDocument?.name ?? '');
  const [disableSave, setDisableSave] = useState(false);

  const deleteHandler = () => {
    const onConfirm = async () => {
      if (bookitupDocument) {
        const { documentType, name } = bookitupDocument;
        const removed = await DocumentTemplateS.remove(documentType, name);
        if (removed) {
          navigate('/settings/templates');
          return true;
        }
      }
      return false;
    };
    openDeleteConfirmModal({
      title: 'Wirklich löschen',
      description: <Text>Möchtest Du dieses Dokument wirklich löschen?</Text>,
      onConfirm,
    });
  };

  const changeName = async () => {
    if (bookitupDocument) {
      const templateName = newName.trim();
      const resJSON = await DocumentTemplateS.edit(bookitupDocument.id, { name: templateName });
      if (resJSON) {
        navigate(`/settings/template/document/${bookitupDocument.documentType.toLowerCase()}/${templateName}`);
      }
    }
  };

  return (
    <>
      <Group>
        <TemplatePreview
          name={bookitupDocument?.name}
          documentType={bookitupDocument?.documentType}
          style={undefined}
        />
        <Menu shadow="md" transition="scale-y" position="bottom-end">
          <Menu.Target>
            <ActionIcon>
              <IconDots />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item icon={<IconBallpen size={16} />} onClick={toggle}>
              Namen ändern
            </Menu.Item>
            <Menu.Item color="red" onClick={deleteHandler} icon={<IconTrash size={16} />}>
              Löschen
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>
      <ModalDialog
        header={<Trans id="Name der Vorlage ändern" />}
        body={
          <div>
            <div>Wähle einen Namen für diese Vorlage:</div>
            <GenericTemplateName
              disableSave={setDisableSave}
              documentType={bookitupDocument?.documentType}
              name={bookitupDocument?.name}
              newName={newName}
              setNewName={setNewName}
              groupName={undefined}
              setGroupName={undefined}
              existingGroups={undefined}
            />
          </div>
        }
        footer={
          <div>
            <TransButtonPrimary
              disabled={disableSave}
              onClickHandler={() => {
                changeName();
                toggle();
              }}
              text="actions.save"
            />
            <TransButtonDefault onClickHandler={toggle} text="actions.cancel" />
          </div>
        }
        show={show}
        toggle={toggle}
      />
    </>
  );
};

export default DocumentTemplateActions;
